import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
export default function DateField({ children }) {
    return (React.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils }, children));
}
//# sourceMappingURL=index.js.map